<div
  class="position-relative"
  (mouseleave)="delayedCloseCard()"
  (mouseenter)="cancelClose()"
>
  <button
    class="btn btn-icon-only btn-lg dropdown-toggle"
    type="button"
    id="dropdownMenuButton"
    (click)="toggleCard()"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <i class="modus-icons notranslate">apps</i>
  </button>
  <div
    class="web-tools-menu dropdown-menu dropdown-menu-right pb-0 shadow-sm"
    [ngClass]="{ show: isOpen }"
    aria-labelledby="dropdownMenuButton"
    role="menu"
    container="body"
  >
    <div class="scroll scrollbar-size">
      <ng-container *ngIf="licensedApps$ | async as licensedApps">
        <h6 class="type-header" *ngIf="licensedApps.length > 0">
          <span> Licensed Apps</span>
          <span
            (click)="isOpen = false"
            class="cursor-pointer ico ico-times-circle pull-right"
            style="top: -1px; font-size: 16px"
          ></span>
        </h6>

        <ul class="list-group">
          <li
            class="cursor-pointer list-group-item"
            *ngFor="let product of licensedApps"
          >
            <div *ngIf="product.licensed">
              <a
                (click)="goToAppPage(product)"
                class="product-row d-flex text-decoration-none"
              >
                <img
                  [src]="product.imageSource"
                  height="40"
                  width="40"
                  alt=""
                  class="mr-3"
                />
                <div class="card-caption">
                  <h6 class="dropdown-header mb-0 p-0">{{ product.name }}</h6>
                  <span>{{ product.description }}</span>
                </div>
              </a>
            </div>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="unlicensedApps$ | async as unlicensedApps">
        <h6 *ngIf="unlicensedApps.length > 0" class="type-header">
          Unlicensed App
        </h6>
        <ul class="list-group">
          <li
            class="list-group-item cursor-pointer"
            *ngFor="let product of unlicensedApps"
            (click)="toggleUnlicensedProductInfo(product, $event)"
          >
            <div *ngIf="!product.licensed">
              <a class="product-row d-flex text-decoration-none">
                <img
                  [src]="product.imageSource"
                  height="40"
                  width="40"
                  alt=""
                  class="mr-3"
                />
                <div class="card-caption">
                  <h6 class="dropdown-header mb-0 p-0">{{ product.name }}</h6>
                  <span>{{ product.description }}</span>
                </div>
              </a>
              <div
                *ngIf="product.showUnlicensedMessage"
                class="unlicensed-message"
              >
                <small class="text-warning">
                  You are not licensed for this app</small
                >
                <a (click)="goToAppPage(product)" class="btn btn-text-primary">
                  Learn More</a
                >
              </div>
            </div>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="expiredApps$ | async as expiredApps">
        <h6 *ngIf="expiredApps.length > 0" class="type-header">Expired Apps</h6>
        <ul class="list-group">
          <li
            class="list-group-item cursor-pointer"
            *ngFor="let product of expiredApps"
            (click)="toggleUnlicensedProductInfo(product, $event)"
          >
            <div *ngIf="!product.productExpired">
              <a class="product-row d-flex text-decoration-none">
                <img
                  [src]="product.imageSource"
                  height="40"
                  width="40"
                  alt=""
                  class="mr-3"
                />
                <div class="card-caption">
                  <h6 class="dropdown-header mb-0 p-0">{{ product.name }}</h6>
                  <span>{{ product.description }}</span>
                </div>
              </a>
              <div
                class="d-flex justify-content-end"
                *ngIf="product.showUnlicensedMessage"
              >
                <small class="text-warning">
                  You are not licensed for this app</small
                >
                <a (click)="goToAppPage(product)" class="btn btn-text-primary"
                  >Learn More</a
                >
              </div>
            </div>
          </li>
        </ul>
      </ng-container>
    </div>
    <div class="d-flex justify-content-between">
      <a class="btn btn-text-danger" (click)="logout()">Logout</a>
    </div>
  </div>
</div>
